import IMApp from "./IMApp";
import IMEventEmitter, { IMEvent } from "./IMEventEmitter";
import IMGroups from "./IMGroups";
import MessageType from "./IMMessageType";
import IMStorage from "./IMStorage";
import StringUtils from "./IMStringUtils";



export default class IMConversation {

    static conversations = [];

    static addOrUpdateConversation(conversation) { 
        IMConversation.conversations[conversation.conversationId] = conversation;
    }

    static getConversation(conversationId) {
        return IMConversation.conversations[conversationId];
    }

    static getConversations() {
        let conversations = [];
        for (const key in IMConversation.conversations) {
            if (Object.hasOwnProperty.call(IMConversation.conversations, key)) {
                const element = IMConversation.conversations[key];
                conversations.push(element);
            }
        }
        IMConversation.sort(conversations);
        return conversations;
    }

    static clearConversation(){
        IMConversation.conversations = []
        IMEventEmitter.emit(IMEvent.UPDATE_CONVERSATION_LIST);
    }

    static getConversationName(conversation) {
        if (conversation && conversation.groupInfo) {
            if (conversation.groupInfo.groupname.length != 0) {
                return conversation.groupInfo.groupname;
            }

            let titleName = '';
            if (conversation.groupInfo.users) {
                conversation.groupInfo.users.forEach(element => {
                    titleName += '、' + element.nickname;
                });
            }
            return titleName.substring(1, titleName.length);
        }
        return '';
    }

    static clearUnReadCount(conversationId) {
        if (IMConversation.conversations[conversationId]) {
            IMConversation.conversations[conversationId].unreadCount = 0;
        }
    }

    static updateConversationLastMessage(message) {
        let conversation = IMConversation.getConversation(message.chatkey);
        if (conversation) {
            conversation.lastMsg = message;
        }
    }

    static refreshLastMsg(item) {
        let lastMsg = item.lastMsg;
        let isMute = item.opertime > 0;

        let lastMsgContent = '';
        let lastMsgName = '';
        if (lastMsg == null) {
            lastMsgContent = '';
        } else if (
            lastMsg.msgtype == MessageType.TXT ||
            lastMsg.msgtype == MessageType.CENTER_TIP ||
            lastMsg.msgtype == MessageType.CENTER_TIP_ORDER
        ) {
            lastMsgContent = lastMsg.content;
        } else if (lastMsg.msgtype == MessageType.IMAGE) {
            lastMsgContent = '[图片]';
        } else if (lastMsg.msgtype == MessageType.VIDEO) {
            lastMsgContent = '[视频]';
        } else if (lastMsg.msgtype == MessageType.VOICE) {
            lastMsgContent = '[语音]';
        } else if (lastMsg.msgtype == MessageType.REDBAG) {
            lastMsgContent = '[红包]';
        } else if (lastMsg.msgtype == MessageType.SHARE_LINK) {
            lastMsgContent = '[链接]';
        } else if (lastMsg.msgtype == MessageType.CARD) {
            lastMsgContent = '[名片]';
        } else if (lastMsg.msgtype == MessageType.CARD_GROUP) {
            lastMsgContent = '[群名片]';
        } else if (lastMsg.msgtype == MessageType.FILE) {
            lastMsgContent = '[文件]';
        } else if (lastMsg.msgtype == MessageType.GET_REDBAG) {
            let d = JSON.parse(lastMsg.content);
            if (d.recvuid == IMApp.user.uid) {
                if (d.senduid == IMApp.user.uid) {
                    lastMsgContent = '您领取了自己的红包';
                } else {
                    let username = IMApp.getShowNameByUID(d.senduid);
                    if (StringUtils.isEmpty(username)) {
                        username = d.sendname;
                    }
                    lastMsgContent = '您领取了' + (username ? StringUtils.adapterString(username, 20) + '的' : '') + '红包';
                }
            } else {
                if (d.senduid == IMApp.user.uid) {
                    lastMsgContent = d.recvname + '领取了您的红包';
                }
            }
        } else if (
            lastMsg.msgtype == MessageType.VOICE_CHAT ||
            lastMsg.msgtype == MessageType.VOICE_CHAT1
        ) {
            lastMsgContent = '[语音通话]';
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_CONFIRM) {
            try {
                let content = JSON.parse(lastMsg.content);
                let hoster = content.hoster;
                let users = content.users;
                lastMsgContent = "'" + StringUtils.adapterString(IMApp.getShowName(hoster, IMApp.conversationId), 4,) + "'想邀请" + users.length + '位朋友加入群聊';
            } catch (e) {
                lastMsgContent = lastMsg.content;
            }
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_QRCODE) {
            if (lastMsg.uid == IMApp.user.uid) {
                lastMsgContent = '您通过扫描二维码加入群聊';
            } else {
                let content = JSON.parse(lastMsg.content);
                if (content.uid == IMApp.user.uid) {
                    lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过扫描您分享的二维码加入群聊";
                } else {
                    lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过扫描'" + StringUtils.adapterString(content.username, 8) + "'分享的二维码加入群聊";
                }
            }
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_GROUP_CODE) {
            if (lastMsg.uid == IMApp.user.uid) {
                lastMsgContent = '您通过邀请链接加入群聊';
            } else {
                lastMsgContent = "'" + StringUtils.adapterString(lastMsg.nickname, 8) + "'通过邀请链接加入群聊";
            }
        } else if (lastMsg.msgtype == MessageType.AT) {
            let content = JSON.parse(lastMsg.content);
            lastMsgContent = content.content;
        } else if (
            lastMsg.msgtype == MessageType.CENTER_TIP_SCREENSHOT ||
            lastMsg.msgtype == MessageType.CENTER_TIP_SCREENSHOT_OPEN
        ) {
            lastMsgContent = IMApp.getText(lastMsg, item.conversationId,);
        } else if (lastMsg.msgtype == MessageType.MONEY_LOG) {
            let content = JSON.parse(lastMsg.content);
            let title = '';
            let Amount_flag = false;
            if (content.amount > 0) {
                Amount_flag = true;
            } else {
                Amount_flag = false;
            }

            if (content.moneytype == 1) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 2) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 3) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 4) {
                title = '到账通知';
            } else if (content.moneytype == 5) {
                title = '支付凭证';
            } else if (content.moneytype == 6) {
                title = '红包退款';
            } else if (content.moneytype == 7) {
                if (Amount_flag) {
                    title = '提现商户通知';
                } else {
                    title = '充值商户通知';
                }
            } else if (content.moneytype == 8) {
                title = '退款到账通知';
            } else if (content.moneytype == 9) {
                if (Amount_flag) {
                    title = '到账通知';
                } else {
                    title = '支付凭证';
                }
            } else if (content.moneytype == 11) {
                title = '支付凭证';
            }
            lastMsgContent = title;
        } else if (
            lastMsg.msgtype == MessageType.TRANSFER_ACCOUNTS ||
            lastMsg.msgtype == MessageType.CENTER_TIP_TRANSFRT
        ) {
            lastMsgContent = '[转账]';
        } else if (lastMsg.msgtype == MessageType.PROGRAME) {
            let content = JSON.parse(lastMsg.content);
            lastMsgContent = '[小程序]' + content.gamename;
        } else if (lastMsg.msgtype == MessageType.CENTER_TIP_NEED_VERFY) {
            lastMsgContent =
                '对方开启了朋友验证，您还不是ta的好友。请先发送朋友验证请求，对方验证通过后，才能聊天';
        } else if (!MessageType.checkIsSupport(lastMsg.msgtype)) {
            lastMsgContent = '收到一条当前版本不支持的消息，请升级版本';
        }

        if (lastMsg && lastMsg.isRecall) {
            let isRecallOther = false;
            let uid = lastMsg.uid;
            isRecallOther = lastMsg.isRecallOther;
            if (isRecallOther) {
                uid = lastMsg.recallID;
            }
            if (uid == IMApp.user.uid) {
                lastMsgContent = (isRecallOther ? '清除' : '撤回') + '了一条消息';
            } else {
                lastMsgContent = (isRecallOther ? '清除' : '撤回') + '了一条消息';
            }
        }

        if (
            item.isGroup &&
            lastMsg &&
            lastMsg.msgtype != MessageType.CENTER_TIP &&
            lastMsg.msgtype != MessageType.CENTER_TIP_CONFIRM &&
            lastMsg.msgtype != MessageType.GET_REDBAG &&
            lastMsg.msgtype != MessageType.CENTER_TIP_QRCODE &&
            lastMsg.msgtype != MessageType.CENTER_TIP_GROUP_CODE
        ) {
            if (lastMsg.uid == IMApp.user.uid) {
                lastMsgName = '您';
            } else {
                lastMsgName = IMApp.getShowName(lastMsg, item.conversationId);
            }
        }

        if (isMute && lastMsgContent != '' && item.unreadCount > 1) {
            lastMsgContent = `[${item.unreadCount}条]` + lastMsgContent;
        }

        let inputMsg = IMApp.saveDocs[item.conversationId];
        if (!StringUtils.isEmpty(inputMsg)) {
            item.lastMsgNameIsRed = true;
            lastMsgName = '[草稿]';
            lastMsgContent = inputMsg;
        }

        if (lastMsg && IMApp.isSnap(lastMsg)) {
            lastMsgContent = '[阅后即焚]';
        }

        if (StringUtils.isEmpty(lastMsgName)) {
            if (StringUtils.isEmpty(lastMsgContent)) {
                lastMsgName = ' ';
                lastMsgContent = ' ';
            } else {
                lastMsgName = lastMsgContent;
                lastMsgContent = ' ';
            }
        }

        if (item.ctype == 1) {
            lastMsgName = item.gamedes;
            lastMsgContent = '';
        }

        item.lastMsgName = lastMsgName;
        item.lastMsgContent = lastMsgContent;
    };

    static deleteChatMsg(result, chatmsgno) {
        let index = -1;
        for (let i = 0; i < result.length; i++) {
            if (result[i].chatmsgno < chatmsgno + 1) {
                index = i;
            }
        }
        if (index != -1) {
            result.splice(0, index + 1);
            return true;
        }
        return false;
    }

    static getLastMsg(message) {
        if (message.msgtype == MessageType.GET_REDBAG) {
            //过滤领取红包消息与自己无关
            let content = JSON.parse(message.content);
            if (content.senduid != IMApp.user.uid || content.recvuid != IMApp.user.uid) {
                return null;
            }
        } else if (message.msgtype === MessageType.CENTER_TIP_CONFIRM) {
            let flag = false;
            let group = IMGroups.getGroup(message.chatkey);
            if (IMGroups.isAdmin(group) || IMGroups.isHost(group)) {
                flag = true;
            }
            if (!flag) {
                return null;
            }
        } else if (message.msgtype === MessageType.RECALL) {
            return null;
        } else if (message.msgtype === MessageType.CONFIRM_ORDER) {
            return null;
        }
        return message;
    }

    static checkAddConversation(messages) {
        let deleMsgNo = IMApp.getDeleteMsgNO(messages[0].chatkey);
        if (deleMsgNo) {
            IMConversation.deleteChatMsg(messages);
            IMApp.removeDeleteMsgNo(messages[0].chatkey);
        }

        let realLastMsg = messages[messages.length - 1];
        let lastMsg = null;
        let atChatMsgno = null;
        for (let i = 0; i < messages.length; i++) {
            let lastMsg1 = IMConversation.getLastMsg(messages[i]);
            if (lastMsg1) {
                lastMsg = lastMsg1;
            }

            if (messages[i].msgtype == MessageType.AT) {
                let uids = JSON.parse(messages[i].content).uids;
                let index = uids.indexOf(IMApp.user.uid);
                if (index >= 0) {
                    atChatMsgno = messages[i].chatmsgno;
                }
            }
        }
        let conversationId = realLastMsg.chatkey;
        let conversation = IMConversation.getConversation(conversationId);
        let opertime = IMApp.getValue(IMApp.muteList, conversationId);
        let isChatTop = IMApp.getValue(IMApp.chatTopList, conversationId);
        let len = 0;
        if (conversation) {
            for (let i = 0; i < messages.length; i++) {
                if (conversation.chatmsgno < messages[i].chatmsgno &&
                    MessageType.checkNormalMsg(messages[i].msgtype) &&
                    IMApp.user.uid != messages[i].uid) {
                    len = len + 1;
                }
            }
            if (conversation.unreadCount && !deleMsgNo) {
                conversation.unreadCount = conversation.unreadCount + len;
            } else {
                conversation.unreadCount = len;
            }
            conversation.opertime = opertime;
            conversation.isChatTop = isChatTop;
            conversation.chatmsgno = realLastMsg.chatmsgno;
            if (lastMsg) {
                if (conversation.lastTime < lastMsg.msgtime) {
                    conversation.lastTime = lastMsg.msgtime;
                    conversation.lastMsg = lastMsg;
                }
            } else if (deleMsgNo) {
                conversation.lastMsg = null;
            }
            if (!conversation.atChatMsgno) {
                conversation.atChatMsgno = atChatMsgno;
            }
        } else {
            let uids = [];
            if (realLastMsg.isGroup) {
            } else {
                uids.push(IMApp.getOtherId(conversationId, IMApp.user.uid));
            }
            if (lastMsg) {
                for (let i = 0; i < messages.length; i++) {
                    if (MessageType.checkNormalMsg(messages[i].msgtype) && IMApp.user.uid != messages[i].uid) {
                        len = len + 1;
                    }
                }
                conversation = {
                    conversationId: conversationId,
                    chatmsgno: realLastMsg.chatmsgno,
                    lastTime: lastMsg.msgtime,
                    lastMsg: lastMsg,
                    unreadCount: len,
                    isGroup: realLastMsg.isGroup,
                    uids: uids,
                    groupName: null,
                    opertime: opertime,
                    isChatTop: isChatTop,
                    atChatMsgno: atChatMsgno,
                };
                IMConversation.addOrUpdateConversation(conversation)
            }
        }
        IMConversation.refreshLastMsg(conversation);
        if (len > 0 && !opertime) {
            if (IMApp.getCurTime() - IMApp.server_time < 2) {
                if (!IMApp.isPlaySound) {
                    IMApp.isPlaySound = true;
                }
            }
        }
        if (realLastMsg.isGroup) {
            IMGroups.refreshGroup(realLastMsg.chatkey, { chatmsgno: realLastMsg.chatmsgno });
        }
        return conversation;
    }

    static sort(conversations) {
        conversations.sort(function (a, b) {
            if (a.isChatTop != b.isChatTop) {
                return b.isChatTop - a.isChatTop;
            }
            if (a.lastMessage && b.lastMessage) {
                return b.lastMessage.msgtime - a.lastMessage.msgtime;
            }
            return 0;
        });
    }

    static addMessage(messages) {
        let conversation = IMConversation.checkAddConversation(messages);
        if (!conversation) {
            IMConversation.addMessage1(messages, conversation);
        } else {
            console.log('addMessage=>', messages)
        }
    }

    static addMessage1(messages, conversation) {
        let conversationId = messages[0].chatkey;
        let filename = IMApp.getChatName(conversationId);
        let obj = IMStorage.get(IMApp.user.uid, filename);
        if (obj) {
            for (let j = 0; j < messages.length; j++) {
                let message = messages[j];
                let needAdd = true;
                for (let i = 0; i < obj.length; i++) {
                    if (obj[i].chatkey === message.chatkey && obj[i].chatmsgno === message.chatmsgno) {
                        needAdd = false;
                    }
                    if (message.msgtype === MessageType.CENTER_TIP_CONFIRM1) {
                        let content = JSON.parse(message.content);
                        if (
                            obj[i].chatkey === message.chatkey &&
                            obj[i].chatmsgno === content.chatmsgno
                        ) {
                            obj[i].isHandled = true;
                        }
                    } else if (message.msgtype === MessageType.RECALL) {
                        let content = JSON.parse(message.content);
                        if (
                            obj[i].chatkey === message.chatkey &&
                            obj[i].chatmsgno === content.chatmsgno
                        ) {
                            needAdd = false;
                            obj[i].isRecall = true;
                            obj[i].isRecallOther = content.isRecallOther;
                            obj[i].uid = message.uid;
                            obj[i].nickname = message.nickname;
                        }

                        if (conversation && conversation.lastMsg &&
                            conversation.lastMsg.chatmsgno == content.chatmsgno) {

                            conversation.lastMsg.isRecall = true;
                            conversation.lastMsg.isRecallOther = content.isRecallOther;
                            conversation.lastMsg.uid = message.uid;
                            conversation.lastMsg.nickname = message.nickname;
                            conversation.lastTim = message.msgtime;
                            IMConversation.refreshLastMsg(conversation);
                        }
                    }
                }
                if (message.msgtype === MessageType.REDBAG) {
                    let data = JSON.parse(message.content);
                    data.hostuid = message.uid;
                } else if (message.msgtype == MessageType.GET_REDBAG) {
                    //过滤领取红包消息与自己无关
                    let content = JSON.parse(message.content);
                    if (content.senduid !== IMApp.user.uid && content.recvuid !== IMApp.user.uid) {
                        needAdd = false;
                    }
                    //红包信息里面新增已领取的id
                    //RedbagUtil.addGetId(content.redbag_id, content.recvuid);
                    IMEventEmitter.emit('REFRESH_REDBAG_INFO', content.redbag_id);
                }
                needAdd && obj.push(message);
            }
        } else {
            obj = messages;
        }
        IMStorage.set(IMApp.user.uid, filename, obj);
    }

    static refreshMessageByClientKey(message) {
        let conversationId = message.chatkey;
        let filename = IMApp.getChatName(conversationId);
        let obj = IMStorage.get(IMApp.user.uid, filename);
        if (!obj) return;
        console.log('refreshMessageByClientKey', obj);

        if (obj) {
            obj.forEach(element => {
                if (element) {
                    if (element.chatmsgno + '' == message.clientkey) {
                        element.chatmsgno = message.chatmsgno;
                        element.msgState = message.msgState;
                        element.clientkey = '';
                        IMStorage.set(IMApp.user.uid, filename, obj);
                        return;
                    }
                }
            });
        }
    }

    static refreshMessageReadState(data) {
        let conversationId = data.chatkey;
        let chatmsgno_list = data.chatmsgno_list;
        let conversations = IMConversation.getConversations();
        let filename = IMApp.getChatName(conversationId);
        for (let i = 0; i < chatmsgno_list.length; i++) {
            conversations.forEach(element => {
                if (chatmsgno_list[i] == element.chatmsgno) {
                    element.isRead = true;
                    element.msgState = 4;
                }
            });
        }
        IMStorage.set(IMApp.user.uid, filename, conversations);
    }
}